/**
 * Persists a parent-invite code across the auth flow (e.g. if email-OTP
 * routes an unconfirmed legacy password account through /auth/verify and
 * back). The normal path never needs this -- the code lives in the
 * ContinueWithEmailPage's own state -- so this is a defensive fallback, not
 * the primary carrier.
 */
const KEY = "staxed:pending_parent_invite";

export function getPendingParentInvite(): string | null {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(KEY);
}

export function setPendingParentInvite(code: string): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(KEY, code);
}

export function clearPendingParentInvite(): void {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(KEY);
}
